<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Receipt Form</h1>
<div mat-dialog-content>
    <form class="has-cols" [formGroup]="recieptForm" *ngIf="recieptForm" (ngSubmit)="onSubmit()">
        <div class="delivery-colle-data-box">
            <fieldset>
                <legend>Receipt Information</legend>
                <div class="col-48 grid-element">
                    <label for="">SELECT DESTINATARIO</label>
                    <select [(ngModel)]="receiverOptions" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectChange($event)" [attr.disabled]="isEditable ? true : null">
                        <option value="recipient">Destinatario</option>
                        <option value="concierge">Concierge</option>
                        <option value="other">Altro</option>
                    </select>
                </div>

                <!--
                <div class="col-48 grid-element" *ngIf="delivery.serviceType.toLowerCase() === 'hourlyrate'">
                  <label>FASCIA ORARIA RITIRO</label>
                  <div class="time-range" [ngClass]="{'hidden': !!recieptForm.get('isFlexblePickUpTime').value}">
                    <div>
                      <select formControlName="pickUpTime">
                        <option value="06:00-07:00">06:00-07:00</option>
                        <option value="07:00-08:00">07:00-08:00</option>
                        <option value="08:00-09:00">08:00-09:00</option>
                        <option value="09:00-10:00">09:00-10:00</option>
                        <option value="10:00-11:00">10:00-11:00</option>
                        <option value="11:00-12:00">11:00-12:00</option>
                        <option value="12:00-13:00">12:00-13:00</option>
                        <option value="13:00-14:00">13:00-14:00</option>
                        <option value="14:00-15:00">14:00-15:00</option>
                        <option value="15:00-16:00">15:00-16:00</option>
                        <option value="16:00-17:00">16:00-17:00</option>
                        <option value="17:00-18:00">17:00-18:00</option>
                        <option value="18:00-19:00">18:00-19:00</option>
                        <option value="19:00-20:00">19:00-20:00</option>
                        <option value="20:00-21:00">20:00-21:00</option>
                        <option value="21:00-22:00">21:00-22:00</option>
                      </select>
                    </div>
                  </div>
                  <div class="time-range" [ngClass]="{'hidden': !recieptForm.get('isFlexblePickUpTime').value}">
                    <div>
                      <input type="time" [(ngModel)]="pickUpFTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                      <div *ngIf="pickUpFTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                    </div>
                    <div style="text-align: center;">&nbsp;-&nbsp;</div>
                    <div>
                      <input type="time" [(ngModel)]="pickUpTTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                      <div *ngIf="pickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                    </div>
                  </div>
                </div>
                -->
                
                <div *ngIf="otherOption">
                  <div class="col-48 grid-element">
                    <label>DESTINATARIO COGNOME</label>
                    <input type="text" formControlName="receiverSurname" [attr.disabled]="isEditable ? true : null" >
                  </div>
                  <div class="col-48 grid-element">
                      <label>DESTINATARIO NOME</label>
                      <input type="text" formControlName="receiverName" [attr.disabled]="isEditable ? true : null" >
                  </div>
                </div>
                <br class="clear">

                <div *ngIf="isWarehouseService() && delivery?.deliveryProducts?.length > 0" formArrayName="deliveryProducts">
                  <div *ngFor="let item of deliveryProductsArray.controls; let i = index" [formGroupName]="i" class="product-dimension-block">
                    <fieldset>
                      <legend>
                        <b style="text-transform: uppercase;">
                          {{ delivery.deliveryProducts[i]?.product?.name }}
                        </b>
                      </legend>

                      <div class="col-48 grid-element">
                        <label>LUNGHEZZA (CM)</label>
                        <input type="number" formControlName="length">

                        <small class="error" *ngIf="getControl(i,'length')?.touched && getControl(i,'length')?.invalid">
                          <span *ngIf="getControl(i,'length')?.errors?.required">Campo obbligatorio</span>
                          <span *ngIf="getControl(i,'length')?.errors?.min">Min 1</span>
                        </small>
                      </div>

                      <div class="col-48 grid-element">
                        <label>LARGHEZZA (CM)</label>
                        <input type="number" formControlName="width">

                        <small class="error" *ngIf="getControl(i,'width')?.touched && getControl(i,'width')?.invalid">
                          <span *ngIf="getControl(i,'width')?.errors?.required">Campo obbligatorio</span>
                          <span *ngIf="getControl(i,'width')?.errors?.min">Min 1</span>
                        </small>
                      </div>

                      <div class="col-48 grid-element">
                        <label>ALTEZZA (CM)</label>
                        <input type="number" formControlName="height">

                        <small class="error" *ngIf="getControl(i,'height')?.touched && getControl(i,'height')?.invalid">
                          <span *ngIf="getControl(i,'height')?.errors?.required">Campo obbligatorio</span>
                          <span *ngIf="getControl(i,'height')?.errors?.min">Min 1</span>
                        </small>
                      </div>

                      <div class="col-48 grid-element">
                        <label>PESO (KG)</label>
                        <input type="number" formControlName="weight">

                        <small class="error" *ngIf="getControl(i,'weight')?.touched && getControl(i,'weight')?.invalid">
                          <span *ngIf="getControl(i,'weight')?.errors?.required">Campo obbligatorio</span>
                          <span *ngIf="getControl(i,'weight')?.errors?.min">Min 0.1</span>
                        </small>
                      </div>
                    </fieldset>
                  </div>
                </div>

                <div class="col-48 grid-element">
                    <label>RECEIPT</label>
                    <input type="file" name="receipt" (change)="onFileSelect($event)" [attr.disabled]="isEditable ? true : null" />
                    <div *ngIf="imageControl?.errors?.invalidImage" style="color: red;">Please select a valid image file (jpg, jpeg, png, gif).</div>
                </div>

                <div class="grid-element-full" *ngIf="delivery?.serviceType?.toLowerCase() === 'fixedprice'">
                  <div class="signature-wrapper">
                    <h3 class="signature-title">Per favore firma qui sotto</h3>
                    <div class="signature-card">
                      <div class="sign">
                        <signature-pad
                        *ngIf="!delivery?.receiverSign"
                        [options]="signaturePadOptions"
                        (onEnd)="drawComplete()">
                        </signature-pad>
                        <img [src]="delivery?.receiverSign" alt="">
                      </div>
                      <div class="signature-actions">
                        <button type="button" *ngIf="!delivery?.receiverSign" class="btn clear-btn" [disabled]="disabledBtn" (click)="clear()">Clear</button>
                        <button type="button" *ngIf="delivery?.receiverSign" class="btn clear-btn" [disabled]="disabledBtn" (click)="deleteSignature()">Remove Sign</button>
                        <button type="button" *ngIf="!delivery?.receiverSign" class="btn save-btn" [disabled]="disabledBtn" (click)="$event.preventDefault(); save();">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
            </fieldset>
        </div>
    </form>
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button class="btn" (click)=onSubmit() [disabled]="!recieptForm.valid || disabledBtn">
      Salva<i class="ml-10 far fa-save"></i>
    </button>
  </div>
</div>